import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fetchUserOrganisaties } from "./Reducers/actions";

const UserOrganisatiesPage = () => {
  const dispatch = useDispatch();
  const items = useSelector((s) => s.userorganisaties.items);
  const error = useSelector((s) => s.userorganisaties.error);

  useEffect(() => {
    dispatch(fetchUserOrganisaties());
  }, [dispatch]);

  const columns = [
    { dataField: "naam", text: "Naam", sort: true },
    {
      dataField: "aantalLocaties",
      text: "Locaties",
      headerStyle: () => ({ width: "100px" }),
    },
    {
      dataField: "aantalUsers",
      text: "Gebruikers",
      headerStyle: () => ({ width: "120px" }),
    },
    {
      dataField: "actief",
      text: "Actief",
      formatter: (v) => (v ? "✅" : "—"),
      headerStyle: () => ({ width: "80px" }),
    },
    {
      text: "Acties",
      dataField: "_id",
      headerStyle: () => ({ width: "200px" }),
      formatter: (_, row) => (
        <Link className="btn btn-sm btn-warning" to={`/admin/userorganisaties/${row._id}`}>
          Wijzigen
        </Link>
      ),
    },
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Partner-organisaties (locatiebeheerders)</h3>
        <div className="box-tools pull-right">
          <Link className="btn-primary btn btn-box-too btn-sm" to="/admin/userorganisaties/insert">
            <i className="fa fa-plus"></i>&nbsp; Organisatie toevoegen
          </Link>
        </div>
      </div>
      <div className="col-md-12 no-float">
        <div className="box box-primary">
          {error && <div className="alert alert-danger m-2">{error}</div>}
          <div className="box-body box-profile" />
          <BootstrapTable
            wrapperClasses="table-responsive-md"
            keyField="_id"
            data={items}
            columns={columns}
            pagination={paginationFactory()}
          />
        </div>
      </div>
    </div>
  );
};

export default UserOrganisatiesPage;
